import React from 'react'

export default function ItineraryStarIcon() {
    return (
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_10_37237)">
                <path d="M6.03752 9.84763L2.95152 11.4701L3.54102 8.03363L1.04102 5.60013L4.49102 5.10013L6.03402 1.97363L7.57702 5.10013L11.027 5.60013L8.52702 8.03363L9.11652 11.4701L6.03752 9.84763Z" fill="#FFB900" stroke="#FFB900" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_10_37237">
                    <rect width="12" height="12" fill="white" transform="translate(0.0375977 0.972656)" />
                </clipPath>
            </defs>
        </svg>
    )
}
